<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                :caption="Core.Definition.getDefinition('Liste des catégories de produit')"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/product-category/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/product-category"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la catégorie de produit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette catégorie de produit?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'ProductCategoryList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        mounted() {
            this.init()
        },
        data: function () {
            return {
                Core :window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Description'),
                        key: 'shortDescription',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            init() {
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/produits/categories/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
